import { TStepResponse } from "model/program";
import React, { ForwardedRef, useMemo } from "react";
import {
  ProgramSectionItemStyled,
  SectionStepper,
} from "./ProgramSectionItem.styled";
import { ProgramVideoList } from "../ProgramVideoList/ProgramVideoList";

type TProps = {
  section: TStepResponse;
  type?: string;
  isUpdate?: boolean;
};

const ProgramSectionItem = (props: TProps, ref: ForwardedRef<any>) => {
  const { section, type, isUpdate } = props;
  const sectionStepperComponent = useMemo(() => {
    return (
      <SectionStepper>
        {/* <span className="label">{`ステップ${section.stepNumber}: `}</span> */}
        <span className="content">{`${section?.stepName}`}</span>
      </SectionStepper>
    );
  }, [section.stepName]);

  return (
    <ProgramSectionItemStyled ref={ref}>
      {sectionStepperComponent}
      <ProgramVideoList
        type={type}
        isUpdate={isUpdate}
        videos={section?.shumokus}
      />
    </ProgramSectionItemStyled>
  );
};

const ProgramSectionItemRef = React.forwardRef(ProgramSectionItem);

export { ProgramSectionItemRef };
